window.Page = {

    linksDesktop      : document.querySelectorAll('.home-link-container'),
    linksMobile       : document.querySelectorAll('.home-links-mobile .home-link-container'),
    linksMobileActive : null,
    linksContainer    : document.querySelector('.home-links'),
    linksMobileButton : document.querySelector('.home-links-mobile-button'),

    // Let's launch this thing
    liftoff : () => {
        Page.showBackgroundOnHover()
        Page.initMobileGallery()
        Page.advanceMobileGalleryOnButtonClick()
    },

    // My new function block
    showBackgroundOnHover : () => {
        Page.linksDesktop.forEach(link => {
            link.addEventListener('mouseenter' , () => {
                let target = link.dataset.target;
                let background = document.getElementById(target)
                    background.style.opacity = '1';
            })
            link.addEventListener('mouseleave' , () => {
                let target = link.dataset.target;
                let background = document.getElementById(target)
                    background.style.opacity = '0';
            })
        })
    },

    // Mobile Home Gallery
    initMobileGallery : () => {

        // We need to scroll the page to the correct position
        Page.linksMobile.item(4).scrollIntoView()

        let attachTheIntersectionObserver = () => {

            // Grab all the items we need to observe
            const items = Page.linksMobile;

            // Create the observer
            const observer = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        
                        // Activate the correct background
                        let target     = entry.target.dataset.target;
                        let background = document.getElementById(target)
                        document.querySelector('.active-background')?.classList.remove('active-background')
                        background.classList.add('active-background');

                        if (entry.target == items.item(4)) setTimeout(function(){items.item(8).scrollIntoView()},350)
                        if (entry.target == items.item(9)) setTimeout(function(){items.item(5).scrollIntoView()},350)

                        Page.linksMobileActive = entry.target;
                    }
                });
            }, {
                threshold  : 0,
                rootMargin : "-40% 0% -60%",
            });

            // Observe each item
            items.forEach(item => { observer.observe(item); });
        }

        attachTheIntersectionObserver()


    },

    advanceMobileGalleryOnButtonClick : () => {
        Page.linksMobileButton.addEventListener('click' , () => {
            Page.linksMobileActive.nextElementSibling.scrollIntoView({ behavior: "smooth"})
        })
    }

};

Page.liftoff()